import React from "react";

/**
 * "Loved Worldwide" strip — a slim trust bar showing concrete regional
 * traction in USA, Europe, and Australia (where ads will run).
 * Designed to be inserted right under the hero or right above ShopZone.
 */

const REGIONS = [
  {
    flag: "🇺🇸",
    label: "United States",
    headline: "8,400+ sleepers",
    sub: "Featured in Forbes & GQ · NY · LA · Miami",
  },
  {
    flag: "🇬🇧",
    label: "United Kingdom & EU",
    headline: "5,200+ sleepers",
    sub: "Hotels in Paris, Milan & London",
  },
  {
    flag: "🇦🇺",
    label: "Australia & NZ",
    headline: "2,100+ sleepers",
    sub: "Sydney to Auckland · 4.9★ avg.",
  },
];

export default function LovedWorldwide() {
  return (
    <section
      data-testid="loved-worldwide"
      className="py-10 md:py-14 border-y border-black/5 bg-[#fafaf9]"
    >
      <div className="container-x">
        <div className="text-center mb-7">
          <span className="inline-flex items-center gap-2 bg-white border border-black/10 rounded-full px-3.5 py-1.5 text-[10px] uppercase tracking-[0.22em] font-extrabold text-[#0e0e10] shadow-sm">
            🌍 Loved worldwide
          </span>
          <h3 className="mt-4 text-[20px] sm:text-[24px] md:text-[28px] font-black tracking-[-0.01em] text-[#0e0e10]">
            <span className="text-[#0e0e10]">15,700+ sleepers across 3 continents</span>{" "}
            <span className="text-[#8a8a8a] font-extrabold">·</span>{" "}
            <span className="text-[#8a8a8a]">all paying full price.</span>
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 max-w-5xl mx-auto">
          {REGIONS.map((r) => (
            <div
              key={r.label}
              data-testid={`loved-region-${r.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="bg-white border border-black/5 rounded-2xl px-5 py-4 flex items-center gap-4 hover:border-[#0e0e10]/20 transition"
            >
              <div className="text-[32px] leading-none shrink-0">{r.flag}</div>
              <div className="flex-1 min-w-0">
                <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#6b6b72]">
                  {r.label}
                </div>
                <div className="text-[15px] font-extrabold text-[#0e0e10] mt-0.5 leading-tight">
                  {r.headline}
                </div>
                <div className="text-[11px] text-[#6b6b72] mt-0.5 leading-snug">
                  {r.sub}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center text-[11px] text-[#6b6b72]">
          <span className="font-semibold text-[#0e0e10]">
            Free worldwide shipping
          </span>{" "}
          · pre-paid duties · 5–7 day delivery to all regions above
        </div>
      </div>
    </section>
  );
}
